import React from "react";

import {
    Form, Input,
} from 'antd';

import { RegistorClass, CommonScheme } from "../core/ComponentRegistor";

const { TextArea } = Input
export class AntTextarea extends React.Component<any> {
    constructor(props) {
        super(props)
    }
    render() {
        const { formLayout } = this.props;
        const { getFieldDecorator } = this.props.form;
        const formItemLayout = formLayout === 'horizontal' ? {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
        } : null;
        // const formItemLayout = null

        return (
            <Form.Item {...formItemLayout} label={this.props.label || this.props.name}>
                {getFieldDecorator(this.props.formKey, {
                    rules: [{
                        // type: this.props.validator, message: 'The input is not valid E-mail!',
                    }, {
                        required: this.props.required, message: '必填项!',
                    }],
                })(
                    <TextArea rows={4} />
                )}
            </Form.Item>
        )
    }
}

let scheme = Object.assign({}, CommonScheme, {
    children:
        CommonScheme.children.concat([
            {
                class: {
                    componentTag: "AntInput",
                },
                key: "custom",
                name: "文本域自定义属性",
                props: {
                    // span: 6,
                    required: true,
                    label: "文本域自定义属性"
                }
            },
        ])
})

RegistorClass({
    componentTag: "AntTextarea",
    componentObject: AntTextarea,
    componentName: "Ant文本域",
    scheme: scheme,
    defaultProps: {
        span: 24,
        lable: "文本域2",
        required: false
    }
})
// export default AntTextarea